import type { SxProps, Theme } from '@mui/material';

export const textFieldStyle: SxProps<Theme> = {
    marginTop: '4px',
    width: '100%',
    fontSize: '14px',
    '& .MuiOutlinedInput-input': {
        padding: '8px 12px',
    },
    '& .MuiFormHelperText-root': {
        marginLeft: '0px',
    },
};

export const textAreaStyles: SxProps<Theme> = {
    marginTop: '4px',
    width: '100%',
    fontSize: '14px',
    '& .MuiOutlinedInput-root': {
        height: 'auto',
        padding: '8px 12px',
    },
};

export const radioStyles: SxProps<Theme> = {
    '& .MuiTypography-body1': {
        fontSize: '14px',
    },
    '& .MuiRadio-root': {
        color: 'neutral.lightGray',
    },
    '& .Mui-checked': {
        color: 'primary.main',
    },
};

export const selectFieldStyles: SxProps<Theme> = {
    width: '100%',
    marginTop: '4px',
};

export const formFieldContainerStyle: SxProps<Theme> = {
    display: 'flex',
    gap: '24px',
    width: '100%',
};

export const conditionalSectionStyle = (borderColor: string): SxProps<Theme> => ({
    border: `1px solid ${borderColor}`,
    borderRadius: '8px',
    backgroundColor: 'rgba(54, 120, 215, 0.08)',
    padding: '24px',
    width: '100%',
    boxSizing: 'border-box',
    margin: '8px 0',
});

export function radioErrorStyles(theme: Theme): SxProps<Theme> {
    return {
        '& .MuiTypography-body1': {
            fontSize: '14px',
            color: theme.palette.error.main,
        },
        '& .MuiRadio-root': {
            color: theme.palette.error.main,
        },
        '& .Mui-checked': {
            color: theme.palette.error.main,
        },
    };
}
